import { apiFetchFormData } from "@/auth/apiClient";

export type S3UploadResult = {
  url: string;
  originalName?: string;
  size?: number;
};

export async function uploadToS3(file: File, fileFor: string): Promise<S3UploadResult> {
  const form = new FormData();
  form.append("file", file);
  form.append("fileFor", fileFor);
  return apiFetchFormData<S3UploadResult>("/s3/upload", form);
}
